import React from "react";
import noData from "@assets/images/data-not-found.png";
import { Button } from "@mui/material";

const DataNotAvailable = ({ message }) => {
  return (
    <div className="bs-status-msg typ-data-not-available">
      <div className="img-wrap">
        <img src={noData} alt="message icon" />
      </div>
      <div className="cont-wrap">
        <h2 className="st-title">{message ? message : "Data Not Available"}</h2>
      </div>
    </div>
  );
};

export default DataNotAvailable;
